import { faExclamationTriangle, faArrowLeft } from '@fortawesome/pro-light-svg-icons';

import { Icon } from '@/components/ui/icon.component';
import { ModalCloseButton } from '@/components/ui/modal-close-button/modal-close-button.component';
import { SheetClose, SheetHeader } from '@/components/ui/sheet';

interface HeaderModalProps {
  standaloneTabAttention: boolean;
  laboratorialTabAttention: boolean;
  onChangeContentToStandalone(value: boolean): void;
  onOpenChange(): void;
}

export function ScheduleHeaderModal({
  standaloneTabAttention,
  laboratorialTabAttention,
  onOpenChange,
  onChangeContentToStandalone,
}: HeaderModalProps) {
  const title = standaloneTabAttention || laboratorialTabAttention ? 'Atenção' : 'Horários disponíveis';

  return (
    <SheetHeader className="flex flex-row justify-between w-full flex-none pb-4">
      <div className="flex items-center gap-3">
        {standaloneTabAttention && (
          <button onClick={() => onChangeContentToStandalone(false)}>
            <Icon icon={faArrowLeft} size="xl" className="hover:text-gray-900 text-2xl" />
          </button>
        )}
        {laboratorialTabAttention && (
          <Icon icon={faExclamationTriangle} size="xl" className="text-green-500 text-2xl" />
        )}
        <span className="text-2xl font-bold" data-testid="schedule-modal--title">
          {title}
        </span>
      </div>
      <SheetClose
        asChild
        className="self-center"
        onClick={onOpenChange}
        data-testid="schedule-modal--close"
      >
        <ModalCloseButton skipInitialFocus />
      </SheetClose>
    </SheetHeader>
  );
}
